import { render, staticRenderFns } from "./ques81.vue?vue&type=template&id=5b91034d&scoped=true"
import script from "./ques81.vue?vue&type=script&lang=js"
export * from "./ques81.vue?vue&type=script&lang=js"
import style0 from "./ques81.vue?vue&type=style&index=0&id=5b91034d&prod&scoped=true&lang=css"
import style1 from "./ques81.vue?vue&type=style&index=1&id=5b91034d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b91034d",
  null
  
)

export default component.exports